import type { ReactNode } from 'react';

/** Linha de dados da ficha (rótulo e valor). */
export function Linha({ rotulo, children }: { rotulo: string; children: ReactNode }) {
  return (
    <div className="flex flex-wrap justify-between gap-2 border-b border-borda py-2 text-sm last:border-0">
      <dt className="text-tinta-3">{rotulo}</dt>
      <dd className="min-w-0 text-right break-words text-tinta-1">{children}</dd>
    </div>
  );
}

/** Hash longo cortado na tela (inteiro no `title` e no comprovante). */
export const HashCurto = ({ hash }: { hash: string | null | undefined }) =>
  hash ? (
    <span className="font-mono text-xs" title={hash}>
      {hash.slice(0, 16)}...
    </span>
  ) : (
    <>-</>
  );
